export const MAP_INITIAL_ZOOM_LEVEL = 17;
export const REQUIRED_MAP_ZOOM_LEVEL_FOR_FETCHING_MAP_ITEMS = 16;
